module.exports = __webpack_public_path__ + "img/图片2.a7812f9a.png";